import { render, staticRenderFns } from "./FormTransfer.vue?vue&type=template&id=08c754c4&scoped=true&"
import script from "./FormTransfer.vue?vue&type=script&lang=ts&"
export * from "./FormTransfer.vue?vue&type=script&lang=ts&"
import style0 from "./FormTransfer.vue?vue&type=style&index=0&id=08c754c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c754c4",
  null
  
)

export default component.exports